import { render, staticRenderFns } from "./DiscCardBenefits.vue?vue&type=template&id=0987150a&"
import script from "./DiscCardBenefits.vue?vue&type=script&lang=js&"
export * from "./DiscCardBenefits.vue?vue&type=script&lang=js&"
import style0 from "./DiscCardBenefits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports